<template>
    <v-expansion-panel class="elevation-0">
        <v-expansion-panel-header>General</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-simple-table
                dense
                class="property-sheet"
            >
                <template v-slot:default>
                    <tbody>
                        <meta-title-field
                            :video="video"
                            :videos="videos"
                            :multiple-videos="multipleVideos"
                            @input="updateTitle"
                        />
                        <tr v-if="!multipleVideos">
                            <td>Status:</td>
                            <td>
                                <visibility-presenter v-if="video"
                                                      :video="video"
                                />
                            </td>
                        </tr>
                        <tr v-if="!multipleVideos">
                            <td>Video ID:</td>
                            <td>
                                <video-id-presenter v-if="video"
                                                    :video="video"
                                />
                            </td>
                        </tr>
                        <library-link v-if="!multipleVideos && (libraries.length > 1 || canUploadEverywhere)"
                                      :video="video"
                        >
                            <copy-video
                                v-if="canCopy"
                                :video="video"
                            />
                            <move-video
                                v-if="canMove"
                                :video="video"
                                @moved="updateLibrary"
                            />
                        </library-link>
                        <meta-description-field
                            v-if="!multipleVideos && video"
                            :video="video"
                        />
                        <meta-tags-field
                            v-if="video"
                            :video="video"
                        />
                        <tr v-if="!multipleVideos">
                            <td>Upload date:</td>
                            <td>
                                <upload-date-presenter :video="video" />
                            </td>
                        </tr>
                        <tr v-if="!multipleVideos">
                            <td>Uploaded by:</td>
                            <td>
                                <uploaded-by-presenter :video="video" />
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
    import MetaDescriptionField from './fields/meta-description-field';
    import MetaTagsField from './fields/meta-tags-field';
    import MetaTitleField from './fields/meta-title-field';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import Gate from '../../../services/gate';
    import CopyVideo from '@/components/primitives/copy-video';
    import MoveVideo from '@/components/primitives/move-video';
    import LibraryLink from '@/components/controls/video-metadata/library/library-link.vue';
    import VideoIdPresenter from '@/components/controls/video-metadata/presenters/video-id-presenter.vue';
    import VisibilityPresenter from '@/components/controls/video-metadata/presenters/visibility-presenter.vue';
    import UploadDatePresenter from '@/components/controls/video-metadata/presenters/upload-date-presenter.vue';
    import UploadedByPresenter from '@/components/controls/video-metadata/presenters/uploaded-by-presenter.vue';

    export default {
        name: 'MetadataGeneral',
        components: {
            UploadedByPresenter,
            UploadDatePresenter,
            VisibilityPresenter,
            VideoIdPresenter,
            LibraryLink,
            MoveVideo,
            CopyVideo,
            MetaTagsField,
            MetaDescriptionField,
            MetaTitleField
        },
        props: ['videos', 'multipleVideos', 'video'],
        data() {
            return {
            };
        },
        computed: {
            ...mapState('auth', ['user']),
            ...mapState('libraries', ['libraries']),
            ...mapGetters('libraries', ['allowedLibrariesBy']),
            ...mapGetters('auth', ['canUploadEverywhere']),
            hasSourceLibraries()
            {
                return this.allowedLibrariesBy(this.user.permissions['copy-from-library']).length > 0;
            },
            hasTargetLibrariesForMove()
            {
                return this.allowedLibrariesBy(this.user.permissions['move-to-library'])
                    .filter(library => library.id !== this.video.library).length > 0;
            },
            hasTargetLibrariesForCopy()
            {
                return this.allowedLibrariesBy(this.user.permissions['copy-to-library'])
                    .filter(library => library.id !== this.video.library).length > 0;
            },
            canMove() {
                return Gate.allows(this.user, ['moveVideo']) && this.hasSourceLibraries && this.hasTargetLibrariesForMove;
            },
            canCopy()
            {
                return this.canUploadEverywhere || (Gate.allows(this.user, ['copyVideo']) && this.hasSourceLibraries && this.hasTargetLibrariesForCopy);
            },
        },
        methods: {
            ...mapActions('libraries', ['getLibraries']),
            updateTitle(value){
                this.videos[0].title = value;
            },
            updateLibrary(value) {
                this.videos[0].library = value;
            }
        },
        mounted() {
            this.getLibraries();
        }
    };
</script>

<style scoped>

</style>
